export const getSheetMetalQuantity = ({
  partialQuoteRequestLine,
}: {
  partialQuoteRequestLine: { quantity: number };
}) => {
  const quantity = Math.ceil(partialQuoteRequestLine.quantity || 0);

  if (quantity === 0) {
    return 1;
  }

  return quantity;
};
